import { validateTitleInput } from 'src/app/utils/general-functions/general-functions.utils';
import { ModalConfigs } from 'src/app/interfaces/modal.interface';

export const modalConfig: ModalConfigs = {
	deleteNode: {
		title: $localize`Delete node`,
		message: $localize`Are you sure you want to delete this node?`,
		confirmText: $localize`Delete`,
		showCheckbox: true,
	},
	deleteGroup: {
		title: $localize`Delete group`,
		message: $localize`Are you sure you want to delete this group?`,
		confirmText: $localize`Delete`,
		showCheckbox: true,
	},
	deleteSelection: {
		title: $localize`Delete selection`,
		message: $localize`Are you sure you want to delete the selected nodes? Any nodes which are part of a running workflow will not be deleted.`,
		confirmText: $localize`Delete`,
	},
	deleteWorkflowRunning: {
		title: $localize`Delete workflow`,
		message: $localize`Are you sure you want to delete this workflow? Deleting a running workflow requires saving the workspace.`,
		confirmText: $localize`Delete`,
	},
	deleteWorkflowPaused: {
		title: $localize`Delete workflow`,
		message: $localize`Are you sure you want to delete this workflow?`,
		confirmText: $localize`Delete`,
	},
	renameNode: {
		title: $localize`Rename node`,
		message: $localize`Nodes and groups of nodes can be renamed. What would you like the new name to be?`,
		confirmText: $localize`Rename`,
		showTextInput: true,
		textInputLabel: $localize`Node name`,
		inputValidationCallback: validateTitleInput,
	},
	renameGroup: {
		title: $localize`Rename group`,
		message: $localize`Nodes and groups of nodes can be renamed. What would you like the new name to be?`,
		confirmText: $localize`Rename`,
		showTextInput: true,
		textInputLabel: $localize`Group name`,
		inputValidationCallback: validateTitleInput,
	},
	renameFailed: {
		title: $localize`Error renaming node`,
		message: $localize`There was an error renaming this node. Would you like to try again?`,
		confirmText: $localize`Try Again`,
		headerIcon: 'ic_error',
	},
	settingsSaveFailed: {
		title: $localize`Error saving`,
		message: $localize`There was an error saving your settings. Would you like to try again?`,
		confirmText: $localize`Try Again`,
		headerIcon: 'ic_error',
	},
	pauseAllWorkflows: {
		title: $localize`Pause all workflows`,
		message: $localize`If this action is confirmed, all workflows in your agency will be disabled regardless of their current states.`,
		headerIcon: 'ic_error',
	},
	startAllWorkflows: {
		title: $localize`Resume all workflows`,
		message: $localize`If this action is confirmed, all workflows in your agency will return to their displayed states.`,
		headerIcon: 'ic_error',
	},
	thresholdExceeded: {
		title: $localize`Timeout threshold exceeded`,
		message: '', // This gets filled later
		cancelButtonText: $localize`Got it`,
		confirmText: $localize`Show me`,
		headerIcon: 'ic_error',
	},
	explainDeletedNodes: {
		title: $localize`This is a deleted node`,
		message: $localize`This node is no longer being reported as a capability from the source product. It is recommended to remove or replace all instances of this node from workflows, as this node is no longer functional.`,
		confirmText: $localize`Got it`,
		hideCancelButton: true,
	},
	requestWorkflowTitle: {
		title: $localize`Set workflow title`,
		message: $localize`Your new workflow must have a title. What would you like to call it?`,
		confirmText: $localize`Set title`,
		showTextInput: true,
		textInputLabel: $localize`Workflow title`,
		inputValidationCallback: validateTitleInput,
	},
	deleteView: {
		title: $localize`Delete workspace`,
		// Clone this object, and replace {{workspaceName}} token with proper value
		message: $localize`:DO NOT TRANSLATE "{{workspaceName}}":Are you sure you want to delete the workspace: "{{workspaceName}}"? Deleting this workspace will delete all of its workflows.`,
		confirmText: $localize`Delete`,
		showTextInput: true,
		textInputLabel: $localize`:DO NOT TRANSLATE "{{workspaceName}}":Type "{{workspaceName}}" to confirm`,
		disableClose: true,
	},
	reviewAgreementsClose: {
		title: $localize`Close without accepting agreements`,
		message: $localize`You will not be able to access Orchestrate if you decline the agreement(s). Are you sure you still want to exit?`,
		confirmText: $localize`Yes`,
		cancelButtonText: $localize`Go back`,
		disableClose: true,
	},
	confirmDeleteWorkspaceDisable: {
		title: $localize`Are you sure you want to delete?`,
		message: $localize`Deleting this will remove the disable workspace on trigger settings and operations will resume as normal.`,
		message2: $localize`Would you like to proceed?`,
		confirmText: $localize`Yes`,
		cancelButtonText: $localize`No`,
		headerIcon: 'ic_timeline_cancel',
		disableClose: true,
	},
	confirmCancelWorkspaceDisableTimer: {
		title: $localize`Are you sure you want to cancel?`,
		message: $localize`Canceling the timer will re-enable the workspace and operations will resume as normal.`,
		message2: $localize`Would you like to proceed?`,
		confirmText: $localize`Yes`,
		cancelButtonText: $localize`No`,
		headerIcon: 'ic_timeline_cancel',
		disableClose: true,
	},
};

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
